import React, { useEffect, useState } from 'react'
import { Button, Header } from '../../components'
import { Bs7Circle, BsPlusCircleFill, BsTrash } from 'react-icons/bs';
import { Link, useNavigate } from 'react-router-dom';
import axiosClient from '../../axios-client';
import Loading from '../../components/Loading';
import { useStateContext } from '../../contexts/ContextProvider';
import { AiTwotoneEdit } from 'react-icons/ai';
import ActionButton from '../../components/ActionButton';
import AddCoefficient from './AddCoefficient';
import EditCoefficient from './EditCoefficient';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import TabHead from '../../components/TabHead';
import MySelect from '../../components/MySelect';
import { IoIosSearch } from 'react-icons/io';
import Alert from '../../components/Alert';
import HourLoading from '../../components/HourLoading';


const Coefficients = () => {
    const navigate = useNavigate();
    const [classes, setClasses] = useState(null);
    const [loading, setLoading] = useState(false);
    const { setToken } = useStateContext();
    const [showAdd, setShowAdd] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [selectedCoeff, setSelectedCoeff] = useState(null);
    const [groupe, setGroupe] = useState([]);
    const [selectedGroupe, setSelectedGroupe] = useState(null);
    const [inputValueGroupe, setValueGroupe] = useState('');
    const [errors, setErrors] = useState([]);
    const handleInputChangeGroupe = value => {
        setValueGroupe(value);
    };



    // handle selection


    // handle selection
    const handleChangeGroupe = value => {
        setSelectedGroupe(value);


    }
    const getCoefficients = () => {
        if (selectedGroupe != null) {
            setLoading(true);
            axiosClient.get('/coefficients?groupe=' + selectedGroupe.id)
                .then((data) => {
                    setClasses(data.data.coefficients);
                    setLoading(false);

                }).catch(err => {
                    const response = err.response;
                    if (response.status === 401) {
                        setToken(null);
                    }
                    else {
                        if (response.status === 422) {
                            setErrors(response.data.errors);
                            setLoading(false);
                            toast.error('Une erreur est survenue!', {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        } else {
                            if (response.status === 403) {
                                navigate('/403');
                            } else {
                                if (response.status === 404) {
                                    navigate('/404');
                                }
                                else {
                                    navigate('/500');
                                }
                            }
                        }

                    }
                })
        } else {
            toast.error('Selectionnez un groupe!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }

    const getGroupes = () => {
        axiosClient.get('/groupes')
            .then((data) => {
                setGroupe(data.data.groupes);
            }).catch(err => {
                navigate('/500');
            })
    }

    const supprimer = (coeff) => {
        Swal.fire({
            title: "Confirmation",
            text: "Etes vous sûre de supprimer cette element ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196F3",
            cancelButtonColor: "#d33",
            confirmButtonText: "Oui!",
            cancelButtonText: "Non!"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosClient.delete('/coefficient/' + coeff.id)
                    .then(response => {
                        toast.success('Opération effectuée avec succès!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        getCoefficients();
                    }).catch(err => {
                        const response = err.response;
                        if (err.response.status === 401) {
                            setToken(null);
                        } else {
                            if (response.status === 401) {
                                setToken(null);
                            }
                            else {
                                if (response.status === 403) {
                                    navigate('/403');
                                } else {
                                    if (response.status === 404) {
                                        navigate('/404');
                                    }
                                    else {
                                        navigate('/500');
                                    }
                                }
                            }
                        }

                    })
            }
        });
    }

    const closeShowAdd = () => {
        setShowAdd(false);
        setSelectedCoeff(null);
        getCoefficients();
    }
    const closeShowEdit = () => {
        setShowEdit(false);
        setSelectedCoeff(null);
        getCoefficients();
    }

    useEffect(() => {
        getGroupes();
    }, []);
    return (
        <>
            <Header icon={<Bs7Circle />} category='Page' title='Coefficients' titleAr="الضوارب و التنقيط" />
            <div className='flex-col '>
                <div className='flex w-full flex-wrap md:flex-nowrap justify-between lg:flex-nowrap xl:flex-nowrap items-center gap-2'>
                    <Button onClick={() => setShowAdd(true)} color="bg-blue-500" icon={<BsPlusCircleFill />} size="20" text="Ajouter" textColor="text-white" />
                    <div className="flex gap-2">
                        <MySelect label="Groupe" labelAr="المجموعة" placeholder="Groupe" cacheOptions defaultOptions value={selectedGroupe} getOptionLabel={e => e.libelle} getOptionValue={e => e.id} options={groupe} onInputChange={handleInputChangeGroupe} onChange={handleChangeGroupe} />
                        <div className="mt-8">
                            <Button onClick={() => getCoefficients()} color="bg-yellow-500" icon={<IoIosSearch />} size="20" text="Chercher" textColor="text-white" />
                        </div>
                    </div>
                </div>
                {errors &&
                    Object.keys(errors).map(key => (
                        <Alert key={key} message={errors[key][0]} />
                    ))
                }
                <div className='mt-3 w-full overflow-x-auto'>
                    {loading ? <HourLoading /> :
                        (
                            <table className='table-auto'>
                                <thead>
                                    <tr>
                                        <th><TabHead left="Groupe" right="المجموعة" />  </th>
                                        <th><TabHead left="Matiere" right="المادة" /> </th>
                                        <th><TabHead left="Coefficient" right="الضارب" /></th>
                                        <th><TabHead left="Note Max" right="التنقيط" /></th>
                                        <th><TabHead left="Ordre" right="الترتيب" /> </th>
                                        <th><TabHead left="Actions" right={"إجراء"} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {classes && classes.map(o => (
                                        <tr key={o.id}>
                                            <td>{o.groupe.libelle}</td>
                                            <td>{o.matiere.libelle}</td>
                                            <td>{o.coefficient}</td>
                                            <td>{o.noteMax}</td>
                                            <td>{o.ordre}</td>
                                            <td>
                                                <div className="flex justify-evenly">
                                                    <ActionButton onClick={() => {
                                                        setSelectedCoeff(o);
                                                        setShowEdit(true);

                                                    }} color="bg-green-500" icon={<AiTwotoneEdit />} textColor="text-white" title="Modifier" />
                                                    <ActionButton onClick={() => { supprimer(o) }} color="bg-red-500" icon={<BsTrash />} textColor="text-white" title="Supprimer" />
                                                </div>
                                            </td>
                                        </tr>
                                    ))

                                    }
                                </tbody>
                            </table>
                        )

                    }


                </div>
                {
                    showAdd ? <AddCoefficient onClose={closeShowAdd} /> : <></>
                }
                {
                    showEdit ? <EditCoefficient ucoefficient={selectedCoeff} onClose={closeShowEdit} /> : <></>
                }
            </div>
        </>
    )
}

export default Coefficients